import { render, staticRenderFns } from "./LetterBoxd.vue?vue&type=template&id=86be3404"
import script from "./LetterBoxd.vue?vue&type=script&lang=js"
export * from "./LetterBoxd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports